"use client";

import { About } from '../About'
import { ScrollBody } from '../ScrollBody'
import { LinkStack } from '../StyledLink'
import { Title } from '../Title'
import styles from './style.module.css'

import alert from '../../public/alert.svg'
import React, {useCallback, useEffect, useState} from "react";
import {useRouter} from "next/navigation";

const Over18Confirmation = ({children, required = true} : React.PropsWithChildren<{required?: boolean}> ) => {
  const [ over18, setOver18 ] = useState<boolean | undefined>( undefined)
  const router = useRouter()

  const onConfirm = useCallback(() => setOver18(true), [])
  const onCancel = useCallback(() => router.back(), [router])

  useEffect(() => {
    if (over18 !== undefined) {
      localStorage?.setItem("over18", JSON.stringify(over18));
    }
  }, [over18]);

  useEffect( () => {
    setOver18(localStorage?.getItem("over18") === 'true');
  }, []);

  if (over18 === undefined && required) {
    return null
  }

  if (over18 || !required) {
    return <>{children}</>
  }
  return (
    <>
      <Title image={alert}>
        Confirm Your Age
      </Title>
      <ScrollBody>
        <About>
          You must be 18+ to view this content. Are you over 18 and willing to see adult content?
        </About>
        <LinkStack>
          <button className={styles.ageGateButton} onClick={onCancel}>Cancel</button>
          <button className={styles.ageGateButton} onClick={onConfirm}>I&apos;m over 18</button>
        </LinkStack>
      </ScrollBody>
    </>
    )
}

export { Over18Confirmation }